import React, { useState, useEffect } from 'react';
import img from '../images/contactimage.webp';
import ReactWhatsapp from 'react-whatsapp';

function WhyComponent() {
    const [formData, setFormData] = useState({
        name: '',
        place: '',
        date: '',
        time: '',
        eventType: '',
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name) {
            newErrors.name = 'Name is required';
        }

        if (!formData.place) {
            newErrors.place = 'Place is required';
        }

        if (!formData.date) {
            newErrors.date = 'Date is required';
        }

        if (!formData.time) {
            newErrors.time = 'Time is required';
        }

        if (!formData.eventType) {
            newErrors.eventType = 'Event Type is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            console.log(formData);
            // Your form submission logic goes here
            setFormData({
                name: '',
                place: '',
                date: '',
                eventType: '',
            });
        }
    };

    useEffect(() => {
        // You can perform additional validation or actions here when form data changes
    }, [formData]);


    const today = new Date().toISOString().split('T')[0]; // Get today's date in ISO format (YYYY-MM-DD)



    return (
        <div className='py-5 px-lg-5' id='Book'>
            <div className="section-ornament">
                <span className="ornament-line"></span>
                <span className="ornament-diamond"></span>
                <span className="ornament-line"></span>
            </div>
            <section className="text-center text-lg-start p-lg-5">
                <div className="container py-4">
                    <div className='d-flex justify-content-center'>
                        <div className="row g-0 align-items-center">
                            <div className="col-lg-6 mb-5 mb-lg-0">
                                <div className="card cascading-right">
                                    <div className="card-body p-lg-5 shadow-5 text-start">
                                        <span className="section-label d-block mb-2">Book An Appointment</span>
                                        <h2 className="fw-bold mt-2 whyHeadFont">Mehandi Magic Unleashed</h2>
                                        <p className='whySlogan mt-3'>" Adorn Yourself with Nature's Elegance "</p>
                                        <div className="container mt-4">
                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3">
                                                    <label htmlFor="name" className="form-label">Name:</label>
                                                    <input
                                                        className="form-control"
                                                        id="name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    {errors.name && <div className="text-danger">{errors.name}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="place" className="form-label">Place:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="place"
                                                        name="place"
                                                        value={formData.place}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    {errors.place && <div className="text-danger">{errors.place}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="date" className="form-label">Date:</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="date"
                                                        name="date"
                                                        value={formData.date}
                                                        onChange={handleChange}
                                                        required
                                                        min={today}
                                                    />
                                                    {errors.date && <div className="text-danger">{errors.date}</div>}
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="eventType" className="form-label">Event Type:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="eventType"
                                                        name="eventType"
                                                        value={formData.eventType}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    {errors.eventType && <div className="text-danger">{errors.eventType}</div>}
                                                </div>
                                                <div className='d-none d-lg-block'>
                                                    {formData.name != '' && formData.date != '' && formData.place != '' && formData.eventType != '' ? <ReactWhatsapp
                                                        type="submit"
                                                        number="+91 9061672817"
                                                        message={`
                                                            I'd like to book an event with the following details:
                                                            Name: ${formData.name}
                                                            Date: ${formData.date}
                                                            Place: ${formData.place}
                                                            Event Type: ${formData.eventType}
                                                            Please let me know if this date and time work for you, and if you need any more information or have any special requests.
                                                            Looking forward to your confirmation!`}
                                                        className="btn btn-outline-dark px-lg-5 px-2 rounded-pill nav-item-head"
                                                    >
                                                        Book<span className='me-2'></span>Now
                                                    </ReactWhatsapp>
                                                        :
                                                        <button type="submit" className="btn btn-outline-dark px-lg-5 px-3 rounded-pill nav-item-head">Book<span className='me-2'></span>Now</button>}
                                                </div>
                                                <div className='d-block d-lg-none'>
                                                    {formData.name != '' && formData.date != '' && formData.place != '' && formData.eventType != '' ? <ReactWhatsapp
                                                        type="submit"
                                                        number="+91 9061672817"
                                                        message={`
                                                            I'd like to book an event with the following details:
                                                            Name: ${formData.name}
                                                            Date: ${formData.date}
                                                            Place: ${formData.place}
                                                            Event Type: ${formData.eventType}
                                                            Please let me know if this date and time work for you, and if you need any more information or have any special requests.
                                                            Looking forward to your confirmation!`}
                                                        className="btn btn-outline-dark px-lg-5 px-2 rounded-pill nav-item-head"
                                                    >
                                                        Book<span className='me-2'></span>Now
                                                    </ReactWhatsapp>
                                                        :
                                                        <button type="submit" className="btn btn-outline-dark px-lg-5 px-3 rounded-pill nav-item-head">Book<span className='me-2'></span>Now</button>}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-5 mb-lg-0 d-none d-lg-block">
                                <img src={img} className="rounded-4 shadow-4 whyImage img-fluid" alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default WhyComponent;

